import React, {useState} from "react";
import styled from "styled-components";
import * as palette from "../Variables";

const StyledAboutListing = styled.div`
    @media (min-width: 768px) {
        max-width: 100%;
    }

    &.left {

        @media (min-width: 992px) {
            margin-right: 24px;
        }
    }

    &.right {

        @media (min-width: 992px) {
            margin-left: 24px;
        }
    }
`;

const AboutListing = ({title, description, list, className}) => {
    return (
        <StyledAboutListing className={className}>
            <h2 className={"h3"}>{title}</h2>
            <p>{description}</p>
            {list}
        </StyledAboutListing>
    )
}

export default AboutListing;